import { render, staticRenderFns } from "./CumulativeActivityElderNumber.vue?vue&type=template&id=19c39822&scoped=true&"
import script from "./CumulativeActivityElderNumber.vue?vue&type=script&lang=js&"
export * from "./CumulativeActivityElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c39822",
  null
  
)

export default component.exports